module.exports = __webpack_public_path__ + "img/story026.c97a4979.webp";